import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import { Outlet, useNavigate } from 'react-router-dom';

import { Page } from 'shared/ui/Page';
import getEnvConfig from 'utils/config/env';

import { tabs } from '../utils/tabs';

const pageSlug = 'admin-current-page';

export const AdminPage = () => {
    const navigate = useNavigate();

    const [tab, setTab] = useState(sessionStorage.getItem(pageSlug) || 'users');

    useEffect(() => {
        sessionStorage.setItem(pageSlug, tab);
    }, [tab]);

    useEffect(() => {
        navigate(`${getEnvConfig().PUBLIC_PATH}/admin/${tab}`);
    }, [tab]);

    return (
        <Page title='Администрирование'>
            <Tabs activeKey={tab} onChange={setTab} items={tabs} />
            <Outlet />
        </Page>
    );
};
